import React from 'react';
import PropTypes from 'prop-types';

import { getPagePath, withLocales } from '@spotahome/soyuz/client';
import { localesShape } from '@spotahome/soyuz/shapes';

import { FooterSimplified as FooterSimplifiedComponent } from '@spotahome/ui-library';

function handleHelpClick(e) {
  e.preventDefault();
  if (typeof zE !== 'undefined') {
    zE.activate({ hideOnClose: true });
  }
}

class Footer extends React.Component {
  static contextTypes = {
    server: PropTypes.shape({
      currentRoute: PropTypes.string
    }),
    request: PropTypes.shape({
      params: PropTypes.object
    })
  };

  static propTypes = {
    locales: PropTypes.shape(localesShape).isRequired
  };

  updateURL = locale => {
    const queryString = window.location.search;
    const currentRoute = this.context.server.currentRoute;
    const params = this.context.request.params;

    window.location =
      getPagePath(currentRoute, { locale, params }) + queryString;
  };

  render() {
    return (
      <FooterSimplifiedComponent
        help={{
          onClick: handleHelpClick
        }}
        locales={{
          current: this.props.locales.current,
          onChange: this.updateURL
        }}
        apps={{
          android: {
            link: 'https://spotahome.app.link/android_footer_listing',
            eventCategory: 'app-promotion',
            eventAction: 'footer-icon-android',
            eventLabel: 'open'
          },
          ios: {
            link: 'https://spotahome.app.link/ios_footer_listing',
            eventCategory: 'app-promotion',
            eventAction: 'footer-icon-ios',
            eventLabel: 'open'
          }
        }}
      />
    );
  }
}

export default withLocales()(Footer);
